export class HttpError extends Error {
  data: any;

  constructor(data: any) {
    if (data && Array.isArray(data) && data.length > 0) {
      super(`HTTP: ${data[0]?.code} - ${data[0]?.description}`);
    } else {
      super('HTTP: unknown');
    }
    this.data = data;
  }
}

